var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgSparkles = function SvgSparkles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 5a.75.75 0 0 1 .72.54l.81 2.85a3.75 3.75 0 0 0 2.58 2.58l2.85.8a.75.75 0 0 1 0 1.45l-2.85.81a3.75 3.75 0 0 0-2.58 2.58l-.81 2.85a.75.75 0 0 1-1.44 0l-.81-2.85a3.75 3.75 0 0 0-2.58-2.58l-2.85-.8a.75.75 0 0 1 0-1.45l2.85-.81a3.75 3.75 0 0 0 2.58-2.58l.8-2.85A.75.75 0 0 1 8.5 5Zm9-3a.75.75 0 0 1 .73.57l.26 1.03c.23.94.97 1.68 1.9 1.91l1.04.26a.75.75 0 0 1 0 1.46l-1.03.26c-.94.23-1.68.97-1.91 1.9l-.26 1.04a.75.75 0 0 1-1.46 0l-.26-1.03a2.63 2.63 0 0 0-1.9-1.91l-1.04-.26a.75.75 0 0 1 0-1.46l1.03-.26a2.63 2.63 0 0 0 1.91-1.9l.26-1.04A.75.75 0 0 1 17.5 2ZM16 15.5a.75.75 0 0 1 .71.51l.4 1.19c.15.44.5.8.94.94l1.19.4a.75.75 0 0 1 0 1.42l-1.19.4c-.44.15-.8.5-.94.94l-.4 1.19a.75.75 0 0 1-1.42 0l-.4-1.19a1.5 1.5 0 0 0-.94-.94l-1.19-.4a.75.75 0 0 1 0-1.42l1.19-.4c.44-.15.8-.5.94-.94l.4-1.19a.75.75 0 0 1 .71-.51Z"
  })));
};

export default SvgSparkles;